<template>
  <div class="modal">
    <div class="modal__content">
      <div class="logo">
        <img :src="_logoSrc" />
      </div>
      <p>
        v1.0.0
      </p>
      <p>
        {{ `sound files now loading ${$data.loadingDots}` }}
      </p>
    </div>
  </div>
</template>

<script>
import LOGO_SIDE from '../assets/logo/logo-side.svg';

export default {
  data() {
    return {
      loadingDots: '',
      intervalObject: {},
    };
  },
  methods: {
    loading() {
      this.$data.intervalObject = setInterval(() => {
        if (this.$data.loadingDots === '') {
          this.$data.loadingDots = '.';
          return;
        }

        if (this.$data.loadingDots === '.') {
          this.$data.loadingDots = '..';
          return;
        }

        if (this.$data.loadingDots === '..') {
          this.$data.loadingDots = '...';
          return;
        }

        if (this.$data.loadingDots === '...') {
          this.$data.loadingDots = '';
          return;
        }
      }, 400);
    },
  },
  computed: {
    _logoSrc() {
      return LOGO_SIDE;
    },
  },
  mounted() {
    this.loading();
  },
  beforeDestroy() {
    clearInterval(this.$data.intervalObject);
  },
};
</script>

<style lang="scss" scoped>
@keyframes loading {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.modal {
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6);
  z-index: 100;

  &__content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 101;
    width: 600px;
    height: 200px;
    border-radius: 5px;
    color: rgb(7, 7, 81);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    animation: loading 0.7s ease-in-out alternate;

    p {
      margin-bottom: 15px;
    }
  }
}

.logo {
  width: 200px;
  margin-bottom: 15px;
  margin-top: -20px;

  img {
    width: 100%;
    height: 100%;
  }
}
</style>
